var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1327 20.1334L21.5327 10.7334L19.666 8.86675L12.1327 16.4001L8.33268 12.6001L6.46602 14.4667L12.1327 20.1334ZM13.9993 27.3334C12.1549 27.3334 10.4216 26.9834 8.79935 26.2834C7.17713 25.5834 5.76602 24.6334 4.56602 23.4334C3.36602 22.2334 2.41602 20.8223 1.71602 19.2001C1.01602 17.5779 0.666016 15.8445 0.666016 14.0001C0.666016 12.1556 1.01602 10.4223 1.71602 8.80008C2.41602 7.17786 3.36602 5.76675 4.56602 4.56675C5.76602 3.36675 7.17713 2.41675 8.79935 1.71675C10.4216 1.01675 12.1549 0.666748 13.9993 0.666748C15.8438 0.666748 17.5771 1.01675 19.1994 1.71675C20.8216 2.41675 22.2327 3.36675 23.4327 4.56675C24.6327 5.76675 25.5827 7.17786 26.2827 8.80008C26.9827 10.4223 27.3327 12.1556 27.3327 14.0001C27.3327 15.8445 26.9827 17.5779 26.2827 19.2001C25.5827 20.8223 24.6327 22.2334 23.4327 23.4334C22.2327 24.6334 20.8216 25.5834 19.1994 26.2834C17.5771 26.9834 15.8438 27.3334 13.9993 27.3334Z",
    fill: "#08C654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d60d83495de5bef35ee7e62948ddfd55.svg";
export { ForwardRef as ReactComponent };